import { Flex, List } from "@chakra-ui/react"
import MenuItem from "components/nav/menuItem"

export default function AuxiliaryMenu({ items = [], isMobile = false }) {
    if (!items.length) return null

    if (isMobile) {
        return (
            <List.Root className="auxiliaryMenu">
                {items.map((item, index) => (
                    <MenuItem
                        key={item.id ?? index}
                        item={item}
                        isMobile={true}
                        className={(item.className || "") + " auxiliaryMenu__item"}
                    />
                ))}
            </List.Root>
        )
    }

    return (
        <Flex as={List.Root} direction="row" gap={6} alignItems="center">
            {items.map((item, index) => (
                <MenuItem key={item.id ?? index} item={item} className={item.className + " auxiliaryMenu__item"} />
            ))}
        </Flex>
    )
}
